import { SuccessorBorrower } from './SuccessorBorrower';

export default SuccessorBorrower;
